import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { BehaviorSubject } from "rxjs";
import { CustomerService } from "./customer.service";
import { WebTransaction, HistoryClient } from "../models";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class TransactionDetailService
{

  branchCustId: string;

  private recentTransactionsSubject: BehaviorSubject<WebTransaction[]> = new BehaviorSubject<WebTransaction[]>(null);
  public recentTransactions: Observable<WebTransaction[]> = this.recentTransactionsSubject.asObservable();

  constructor(
    private historyClient: HistoryClient,
    private customerService: CustomerService,
  )
  {
    this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.branchCustId = customer.BranchCustId;
      });
  }

  public getCustomerHistoryDetail(branchCustId: string, refNum: string, date: Date, tran: string)
  {
    this.historyClient.getCustomerHistoryDetail(branchCustId, refNum, new Date(date), tran)
      .subscribe(history => this.recentTransactionsSubject.next(history));
  }

  public getCustomerHistoryPaymentDetail(branchCustId: string, checkNum: string, date: Date, tran: string)
  {
    this.historyClient.getCustomerHistoryPaymentDetailV2(branchCustId, checkNum, new Date(date), tran)
      .subscribe(history => this.recentTransactionsSubject.next(history));
  }
}
